module.exports = __webpack_public_path__ + "img/Billboard.7a88c1e1.jpg";